import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import {showQuestion} from '../modules/Navigation';
import TagList from './TagList';
import UserComment from './components/UserComment';
import IconStat from './components/IconStat';
import IconStatList from './components/IconStatList';
import AcceptedAnswer from './components/AcceptedAnswer';


@connect(
  () => ({}),
  (dispatch, ownProps) => ({
    onQuestionClick: (e) => {
      e.preventDefault();
      dispatch(showQuestion(ownProps.question.url));
    },
  })
)

// eslint-disable-next-line react/prefer-stateless-function
export default class QuestionRow extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    user: PropTypes.object,
    selectedTag: PropTypes.string,
    widget: PropTypes.bool,
    onQuestionClick: PropTypes.func.isRequired,
  };

  render() {
    const styleHand = {
      cursor: 'pointer',
    };

    const {question, onQuestionClick, widget, selectedTag} = this.props;
    const answered = question.accepted_answer_id ? question.accepted_answer_id : null;

    const voteIcon = question.votes_total >= 0 ? 'thumb-up' : 'thumb-down';

    const statsColumns = [
      <IconStat key="views" name="views" icon="views" value={question.views} />,
    ];

    let voteContent;
    if (!widget) {
      voteContent = <div className="margin-bottom-xs"><IconStatList><IconStat key="votes" name="votes" icon={voteIcon} value={question.votes_total} /></IconStatList></div>;
      statsColumns.push(<IconStat key="answers" name="answers" icon="bubble" value={question.answer_count} />);
    }

    const answeredContent = answered && <div className="margin-bottom-xs"><AcceptedAnswer key="answers" text="Answered" /></div>;

    const moderatedText = question.moderated ? '[moderated]: ' : '';
    const lockedText = question.locked ? '[locked]: ' : '';
    const shorten = (text, limit) => {
      if (!text) {
        return '';
      }
      if (text.length > limit) {
        return `${text.substr(0, text.lastIndexOf(' ', limit))}...`;
      }
      return text;
    };
    const shortenText = shorten(question.content, 200);

    return (
      <div className="posting-grid posting-grid--bottom-border">
        <div className="posting-grid__controls">
          {answeredContent}
          {voteContent}
          <IconStatList>
            {statsColumns}
          </IconStatList>
        </div>
        <div className="posting-grid__content">
          <h2 className="heading heading--bold break-lengthy-words margin-bottom-xs margin-bottom-xs-screen-sm" style={styleHand} onClick={onQuestionClick}>
            {moderatedText} {lockedText} {question.title}
          </h2>
          <UserComment userId={question.user_id} username={question.username} when={question.createdHuman}>
            <p className="text text--sm margin-bottom-sm" style={styleHand} onClick={onQuestionClick}>
              {shortenText}
            </p>
            <TagList tags={question.tags} selectedTag={selectedTag} />
          </UserComment>
        </div>
      </div>
    );
  }
}
